export default __webpack_public_path__ + "static/media/PostgreDB.62c300d4.svg";